import React, { useEffect } from 'react';
import { Theme, CSSTheme, AutoComplete, Item } from 'rewire-ui';
import { makeStyles } from '@material-ui/core/styles';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import DataQueries from '../graphql/Queries';
import sideTogglePanelModel from '../side-navigation/SideTogglePanelModel';
import { IDashboardGuestToken, INameLike } from '../DataTypes';
import { observable, Observe } from 'rewire-core';
import { useWatch } from '../settings/SettingsModel';

const styles = (_theme: Theme) =>
  ({
    root: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      padding: '0px',
      overflow: 'hidden',
      position: 'relative',
      '& iframe': {
        flex: 1,
        border: 0,
        paddingTop: 0,
        margin: 0,
      },
    },
  }) as CSSTheme;

const useReportStyles = makeStyles(styles);

const state = observable({
  dashboardToken: null as IDashboardGuestToken | null,
  dashboards: [] as any[],
  selectedItem: {} as INameLike,
});

function search(text: string): Promise<Item[]> {
  return Promise.resolve(state.dashboards.filter((d) => d.name.toLowerCase().includes(text.toLowerCase())));
}

export default (props: any) => {
  const classes = useReportStyles(props);

  useEffect(() => {
    sideTogglePanelModel.forceClose();
    (async () => {
      const dashboards = await DataQueries.getDashboards();
      console.log('Dashboards:', dashboards);
      state.dashboards.set(dashboards);
      state.selectedItem = dashboards[0] || {};
    })();
    return () => sideTogglePanelModel.forceOpen();
  }, []);

  useWatch(
    () => state.selectedItem,
    async () => {
      if (!state.selectedItem?.id) {
        state.dashboardToken = null;
        return;
      }

      const dashboardToken = await DataQueries.getDashboardGuestToken(state.selectedItem.id);
      state.dashboardToken = dashboardToken;
      if (!dashboardToken) {
        return;
      }
      const doc = document.getElementById('dashboard-wrapper') as any;
      // doc.innerHtml = '';
      embedDashboard({
        id: state.dashboardToken.id, // given by the Superset embedding UI
        supersetDomain: 'https://analytics.worksight.services',
        mountPoint: doc, // any html element that can contain an iframe
        fetchGuestToken: async () => state.dashboardToken!.token,
        dashboardUiConfig: {
          // dashboard UI config: hideTitle, hideTab, hideChartControls, filters.visible, filters.expanded (optional), urlParams (optional)
          hideTitle: true,
          filters: {
            expanded: true,
          },
        },
      });
    },
    true,
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', flex: 1 }}>
      <div style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
        <Observe>
          {() => (
            <AutoComplete
              search={search}
              map={(item: any) => item?.name ?? ''}
              placeholder={'Select Dashboard...'}
              label={'Dashboard'}
              selectOnFocus
              // initialInputValue={state.selectedItem}
              // onValueChange={onValueChange}
              autoFocus
              align={'left'}
              selectedItem={state.selectedItem}
              onSelectItem={(item: INameLike) => {
                state.selectedItem = item;
              }}
              classes={classes}
            />
          )}
        </Observe>
        <div style={{ flex: 3 }} />
      </div>
      {/** biome-ignore lint/correctness/useUniqueElementIds: <explanation> */}
      <div id="dashboard-wrapper" className={classes.root} />
    </div>
  );
};
